import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import DevTools from './views/DevTools.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: "active",
    routes: [
    { path: '/', redirect: '/dashboard' },
    {
      path: '/dashboard',
      name: 'home',
      meta: {
        requiresAuthentication: true
          },
      component: Home
    },
    {
        path: '/devtools',
        name: 'devtools',
        meta: {
            requiresAuthentication: true
        },
        component: DevTools
        },
        {
            path: '/partnerimports',
            name: 'partnerimports',
            meta: {
                requiresAuthentication: true
            },
            component: () => import('./views/PartnerImports.vue')
        },
        {
            path: '/partnerimportrows/:file/:pageNumber?',
            name: 'partnerimportrows',
            meta: {
                requiresAuthentication: true
            },
            component: () => import('./views/PartnerImportRows.vue'),
            props: true
        },
        {
            path: '/util',
            name: 'util',
            meta: {
                requiresAuthentication: true
            },
            component: () => import(/* webpackChunkName: "util" */ './views/SettlementOptionsMatrix.vue')
        },
    {
        path: '/buckets/bucket0',
        name: 'claimsBucket0',
        props: { fastTrack: null, noRelatedReference: true, insuranceLineId: 1 },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimsBucket.1.vue')
    },
    {
      path: '/buckets/bucket1',
      name: 'claimsBucket1',
        props: { fastTrack: null, noRelatedReference: true, insuranceLineId: 2, ignoreNoPolicyData: false, noPolicyData: false },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimsBucket.1.vue')
    },
    {
        path: '/buckets/policefed',
        name: 'claimsBucketPoliceFed',
        props: {
            fastTrack: null, noRelatedReference: true, insuranceLineIds: [5,7] },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimsBucket.1.vue')
    },
    {
        path: '/buckets/bucket11',
        name: 'claimsBucket11',
        props: { fastTrack: null, noRelatedReference: true, insuranceLineId: 2, portalGroupId: 1001 },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimsBucket.1.vue')
    },
    {
        path: '/buckets/bucket2',
        name: 'claimsBucket2',
        props: { fastTrack: true, noRelatedReference: false, noFTManualReview: true },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimsBucket.1.vue')
    },
    {
        path: '/buckets/bucket3',
        name: 'claimsBucket3',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimsBucket.2.vue')
    },
    {
        path: '/buckets/bucket4',
        name: 'claimsBucket4',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimsBucket.1.vue')
    },
    {
        path: '/buckets/bucket5',
        name: 'claimsBucket5',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimsBucket.3.vue')
    },
    {
        path: '/buckets/bucket6',
        name: 'claimsBucket6',
        props: { includeCancelled: false },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimsBucket.4.vue')
    },
    {
        path: '/buckets/bucket7',
        name: 'claimsBucket7',
        props: { includeCancelled: true, ignoreTaskFlags: true },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimsBucket.4.vue')
    },
    {
        path: '/buckets/bucket8',
        name: 'claimsBucket8',
        props: { onlyCancelled: true },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimsBucket.4.vue')
    },
    {
        path: '/buckets/bucket9',
        name: 'claimsBucket9',
        props: { fastTrack: true },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/FTManualReview.vue')
    },
    {
        path: '/buckets/bucket10',
        name: 'claimsBucket10',
        props: { ignoreTaskFlags: true },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimsBucket.3.vue')
    },
    {
      path: '/buckets/bucket1/approve',
      name: 'claimQuickApprove1',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprove.vue')
    },
    {
      path: '/buckets/bucket1/approve/popout',
      name: 'claimQuickApprovePopout1',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprovePopout.vue')
        },
        {
            path: '/buckets/policefed/approve',
            name: 'claimQuickApprovePolicefed',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprove.vue')
        },
        {
            path: '/buckets/policefed/approve/popout',
            name: 'claimQuickApprovePopoutPolicefed',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprovePopout.vue')
        },
    {
        path: '/buckets/bucket2/approve',
        name: 'claimQuickApprove2',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprove.vue')
    },
    {
        path: '/buckets/bucket2/approve/popout',
        name: 'claimQuickApprovePopout2',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprovePopout.vue')
    },
    {
        path: '/buckets/bucket3/approve',
        name: 'claimQuickApprove3',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprove.vue')
    },
    {
        path: '/buckets/bucket3/approve/popout',
        name: 'claimQuickApprovePopout3',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprovePopout.vue')
    },
    {
        path: '/buckets/bucket0/approve',
        name: 'claimQuickApprove0',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprove.vue')
    },
    {
        path: '/buckets/bucket0/approve/popout',
        name: 'claimQuickApprovePopout0',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprovePopout.vue')
    },
    {
        path: '/buckets/bucket4/approve',
        name: 'claimQuickApprove4',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "abbucketsout" */ './views/ClaimQuickApprove.vue')
    },
    {
        path: '/buckets/bucket4/approve/popout',
        name: 'claimQuickApprovePopout4',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprovePopout.vue')
    },
    {
        path: '/buckets/bucket5/approve',
        name: 'claimQuickApprove5',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprove.vue')
    },
    {
        path: '/buckets/bucket5/approve/popout',
        name: 'claimQuickApprovePopout5',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprovePopout.vue')
    },
    {
        path: '/buckets/bucket6/approve',
        name: 'claimQuickApprove6',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprove.vue')
    },
    {
        path: '/buckets/bucket6/approve/popout',
        name: 'claimQuickApprovePopout6',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprovePopout.vue')
    },
    {
        path: '/buckets/bucket7/approve',
        name: 'claimQuickApprove7',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprove.vue')
    },
    {
        path: '/buckets/bucket7/approve/popout',
        name: 'claimQuickApprovePopout7',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprovePopout.vue')
    },
    {
        path: '/buckets/bucket8/approve',
        name: 'claimQuickApprove8',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprove.vue')
    },
    {
        path: '/buckets/bucket8/approve/popout',
        name: 'claimQuickApprovePopout8',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprovePopout.vue')
      },
      {
          path: '/buckets/bucket10/approve',
          name: 'claimQuickApprove10',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprove.vue')
      },
      {
          path: '/buckets/bucket10/approve/popout',
          name: 'claimQuickApprovePopout10',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprovePopout.vue')
      },
    {
        path: '/pipelines',
        name: 'Pipelines',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "pipelines" */ './views/Pipelines.vue')
    },
    {
        path: '/resellerpipelines',
        name: 'ResellerPipelines',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "pipelines" */ './views/ResellerPipelines.vue')
    },
    {
        path: '/resellerpipelines/rules',
        name: 'PipelineRules',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "pipelines" */ './views/PipelineRules.vue')
    },
    {
          path: '/ruleComponents',
          name: 'RuleComponents',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "pipelines" */ './views/RuleComponents.vue')
      },
      {
          path: '/taskHistory',
          name: 'TaskHistory',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "taskhistory" */ './views/TaskHistory.vue')
      },
      {
          path: '/taskhistory/view',
          name: 'TaskHistoryView',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "taskhistory" */ './views/ClaimQuickApprove.vue')
      },
      {
          path: '/taskhistory/view/popout',
          name: 'taskHistoryViewPopout',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "taskhistory" */ './views/ClaimQuickApprovePopout.vue')
      },
       
      {
          path: '/buckets/bucket9/approve',
          name: 'claimQuickApprove9',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprove.vue')
      },
      {
          path: '/buckets/bucket9/approve/popout',
          name: 'claimQuickApprovePopout9',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprovePopout.vue')
      },
      {
          path: '/forms/users',
          name: 'formUser',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "forms" */ './views/formUser.vue')
      },
      {
          path: '/repairoptions/instructions',
          name: 'repairOptionsInstructions',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "repairoptions" */ './views/RepairOptionsInstructions.vue')
      },
      {
          path: '/repairoptions/matrix',
          name: 'repairOptions',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "repairoptions" */ './views/RepairOptions.vue')
      },
      {
          path: '/reports',
          name: 'reports',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "repairoptions" */ './views/Reports.vue')
      },
      {
          path: '/messages',
          name: 'messages',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "repairoptions" */ './views/Messages/Messages.vue')
      },
      {
          path: '/buckets/claimunreadmessages',
          name: 'claimUnreadMessages',
          props: null,
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimsBucket.UnreadMsg.vue')
      },
      {
          path: '/buckets/claimunreadmessages/approve',
          name: 'claimUnreadMessagesApprove1',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprove.vue')
      },
      {
          path: '/buckets/claimunreadmessages/approve/popout',
          name: 'claimUnreadMessagesApprovePopout1',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprovePopout.vue')
      },
      {
          path: '/dashboard/myrecentclaims/approve',
          name: 'MyRecentClaimsApprove',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprove.vue')
      },
      {
          path: '/dashboard/myrecentclaims/approve/popout',
          name: 'MyRecentClaimsApprovePopout',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprovePopout.vue')
      },
    {
            path: '/buckets/settlementoptiontasks',
            name: 'settlementoptiontasks',
            meta: {
                requiresAuthentication: true
            },
            component: () => import(/* webpackChunkName: "buckets" */ './views/SettlementOptionTasks.vue')
        },
        {
            path: '/buckets/settlementoptiontasks/approve',
            name: 'SettlementOptionTasksApprove',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprove.vue')
        },
        {
            path: '/buckets/settlementoptiontasks/popout',
            name: 'SettlementOptionTasksApprovePopout',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "buckets" */ './views/ClaimQuickApprovePopout.vue')
        },
        {
            path: '/finance/customerpayments',
            name: 'customerpayments',
            meta: {
                requiresAuthentication: true
            },
            component: () => import(/* webpackChunkName: "financeBuckets" */ './views/Finance/CustomerPayments/List.vue')
        },
        {
            path: '/buckets/finance/claimpayments',
            name: 'claimpayments',
            meta: {
                requiresAuthentication: true
            },
            component: () => import(/* webpackChunkName: "financeBuckets" */ './views/Finance/ClaimPayments/List.vue')
        },
        {
            path: '/finance/home',
            name: 'financehome',
            meta: {
                requiresAuthentication: true
            },
            component: () => import(/* webpackChunkName: "finance" */ './views/Finance/Home.vue')
        },
        {
            path: '/finance/supplierpayments/import',
            name: 'supplierpaymentsimport',
            meta: {
                requiresAuthentication: true
            },
            component: () => import(/* webpackChunkName: "finance" */ './views/Finance/SupplierPayments/Import.vue')
        },
        {
            path: '/finance/supplierpayments/progress/:id?',
            name: 'supplierpaymentsprogress',
            meta: {
                requiresAuthentication: true
            },
            component: () => import(/* webpackChunkName: "finance" */ './views/Finance/SupplierPayments/FileProgress.vue')
        },
        {
            path: '/finance/supplierpayments/reconciliation/:id',
            name: 'supplierpaymentsreconciliation',
            meta: {
                requiresAuthentication: true
            },
            component: () => import(/* webpackChunkName: "finance" */ './views/Finance/SupplierPayments/Reconciliation.vue')
        }
  ]
})
